export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";